<template>
  <div class="table-wrapper">
    <div class="table-title-wrapper">
      <div class="label-wrapper">
        <div>Project Phases</div>
        <div class="button" @click="buttonClick">Add Project Phase</div>
      </div>
    </div>
    <ag-grid-vue
      style="width: 100%; height: 300px"
      class="ag-theme-material"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      @column-resized="onColumnResized"
      @first-data-rendered="onFirstDataRendered"
      @grid-size-changed="onFirstDataRendered"
      :rowData="rowData"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import ProjectPhasesActions from "./ProjectPhasesActions";
import * as database from "@/vendor/database";

export default {
  data() {
    return {
      projectPhases: null,
      rowData: [],
      gridOptions: null,
      columnDefs: null,
    };
  },
  components: {
    AgGridVue,
    ProjectPhasesActions,
  },
  watch: {
    projectPhases: function () {
      this.rowData = this.projectPhases.map((item) => ({
        name: item.name,
        id: item.id,
      }));
    },
  },
  beforeMount() {
    this.$bind("projectPhases", db.collection("project_phases"));
    this.gridOptions = {
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true,
        autoHeight: true,
      },
      context: {
        componentParent: this,
      },
      animateRows: true,
      enableCellTextSelection: true,
    };
    this.columnDefs = [
      {
        headerName: "Name",
        field: "name",
        flex: 1,
      },
      {
        headerName: "Actions",
        field: "actions",
        width: 180,
        cellClass: ["overflow-visible", "grid-action-flex"],
        cellRendererFramework: "ProjectPhasesActions",
        sortable: false,
        filter: false,
        rowGroup: false,
      },
    ];
  },
  methods: {
    onColumnResized: function (params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    buttonClick: function () {
      this.$emit("buttonClick", { type: "add" });
    },
    deleteProjectPhase: function (data) {
      if (confirm("do you want to delete?")) {
        const id = data.id;
        database.deleteDoc("project_phases", id).then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "delete success",
            });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
  },
};
</script>


<style scoped>
.label-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: inter-regular;
}
.button {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  font-weight: 500;
  font-family: inter-regular;
}
.table-wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
}
.table-title-wrapper {
  padding: 24px 24px 6px;
}
</style>
